/** Browser-safe educational estimates; never persisted or used for quoting. */
export const SERVICE_IDS = ['web','social','contenu','reels','branding','ads','redaction','extra'] as const;
export const LEGACY_SERVICE_IDS = ['evenementiel'] as const;
export const COUNTRY_CPM = [
 { id:'ch', min:8.4,max:14.8,currency:'USD' },
 { id:'fr', min:6.8,max:11.2,currency:'USD' },
 { id:'ae', min:5.4,max:10,currency:'USD' },
 { id:'tn', min:3,max:8,currency:'TND' },
 { id:'in', min:.8,max:2.6,currency:'USD' },
 { id:'us', min:10.5,max:23,currency:'USD' },
] as const;
export function impressions(chf:number, cpm:typeof COUNTRY_CPM[number]) {
 const converted = Math.max(0,chf) * (cpm.currency === 'TND' ? 3.6 : 1.2);
 return { low:Math.round(converted/cpm.max*1000), high:Math.round(converted/cpm.min*1000) };
}
export function marketingBudget(revenue:number) {
 const safe = Number.isFinite(revenue) ? Math.max(0,revenue) : 0;
 return { low:safe*.077,high:safe*.094, monthlyLow:safe*.077/12,monthlyHigh:safe*.094/12,paid:safe*.077*.306 };
}
export function coherence(position:number,production:number) {
 return position === production ? 'coherent' : production < position ? 'under' : 'over';
}
export const FACTORS_BY_SERVICE: Record<string,number[]> = {
 social:[1,2,3,5,6,7],contenu:[0,1,4,6],reels:[0,1,4,5,6],branding:[1,5,6,7],web:[1,5,6,7],ads:[0,1,5,7],redaction:[1,5,6,7],extra:[2,3,4,7],evenementiel:[0,1,3,4],
};
/** "Construis ton profil" — 8 factors, browser-only. `map` links a position to a configurator choice. */
export const PROFILE_FACTORS = [
 { key:'production', options:3, map:['phone','semi','premium'] },
 { key:'team', options:3, map:['junior','confirmed','expert'] },
 { key:'cm', options:3, map:['autonomy','validation','local'] },
 { key:'presence', options:3, map:null },
 { key:'location', options:3, map:['city','near','swiss'] },
 { key:'ambition', options:3, map:['local','national','international'] },
 { key:'position', options:3, map:['local','premium','luxury'] },
 { key:'analysis', options:2, map:null },
] as const;
export type ProfileSelection = (number|null)[];
/** Relative index 1–5 (one decimal); unset factors count as the lowest position. */
export function budgetIndex(sel:ProfileSelection) {
 const total = PROFILE_FACTORS.reduce((sum,f,i)=>{const v=sel[i];return sum+(v==null?0:Math.max(0,Math.min(f.options-1,v))/(f.options-1));},0);
 return Math.round((1+4*total/PROFILE_FACTORS.length)*10)/10;
}
/** URL parameters for the configurator, only for factors the visitor actually set. */
export function profileSearch(sel:ProfileSelection) {
 const out:Record<string,string>={};
 PROFILE_FACTORS.forEach((f,i)=>{const v=sel[i];if(f.map&&v!=null&&f.map[v])out[f.key]=f.map[v];});
 return out;
}
